import { render, staticRenderFns } from "./ztDropdownItem.vue?vue&type=template&id=474b9d7c&"
import script from "./ztDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ztDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports